import { Testimonial } from '@rumblefish/ui/Rumblefish23Theme';
import { StyledTestimonialWrapper } from './Testimonial.styles';
import type { CaseStudyTestimonialProps } from './Testimonial.types';

export const CaseStudyTestimonial = ({
  show,
  name,
  positionInCompany,
  text,
  avatarSrc,
}: CaseStudyTestimonialProps) => {
  if (!show) return null;
  return (
    <StyledTestimonialWrapper>
      <Testimonial
        name={name || ''}
        positionInCompany={positionInCompany || ''}
        text={text || ''}
        avatarSrc={avatarSrc || ''}
      />
    </StyledTestimonialWrapper>
  );
};
